import { useMemo } from "react";
import Calendar, { type DaySums } from "./Calendar";
import { useData } from "@/v2/contexts/DataProvider";

/** Thin wrapper that connects the Calendar component to v2's DataProvider */
export default function CalendarPage() {
	const { entries, exportedEntries } = useData();

	const dailySums = useMemo(() => {
		const sums = new Map<string, DaySums>();
		for (const e of entries) {
			const parts = e.date.split("/");
			if (parts.length !== 3) continue;
			const key = `${parts[2]}-${parts[0]}-${parts[1]}`;
			const prev = sums.get(key) || { exported: 0, tracked: 0 };
			prev.tracked += e.duration;
			sums.set(key, prev);
		}
		for (const e of exportedEntries) {
			const parts = e.date.split("/");
			if (parts.length !== 3) continue;
			const key = `${parts[2]}-${parts[0]}-${parts[1]}`;
			const prev = sums.get(key) || { exported: 0, tracked: 0 };
			prev.exported += e.duration;
			sums.set(key, prev);
		}
		return sums;
	}, [entries, exportedEntries]);

	return <Calendar dailySums={dailySums} />;
}
